import { LOCALE_CURRENCY } from '@/shared/constants/config'

/**
 * Un monto, con su moneda si se sabe cuál es.
 *
 * ── POR QUÉ NO ALCANZA CON PASAR LA MONEDA ──────────────────────────────────
 *
 * **`Intl.NumberFormat` con `style: 'currency'` TIRA si no recibe una moneda.** No degrada, no
 * imprime el número pelado: lanza, y dentro de un componente eso rompe el render y se lleva la
 * pantalla —«Algo salió mal»— por un símbolo.
 *
 * Verificado en Node el 2026-08-07:
 *
 * | `currency` | Qué pasa |
 * | --- | --- |
 * | `'GTQ'` | `Q 1,234.50` |
 * | `undefined` | **TypeError** — «Currency code is required with currency style» |
 * | `null` | **RangeError** — «Invalid currency code» |
 * | sin `style` | `1,234.5` |
 *
 * ☠️ Por eso `currency: currency ?? undefined` **no protege nada**: cambia un valor que tira por
 * otro que tira. Estaba escrito así en tres lugares del carril, y se lee como una defensa.
 *
 * ── CUÁNDO FALTA LA MONEDA ──────────────────────────────────────────────────
 *
 * No es hipotético desde que las pantallas leen v2: la moneda salía del store, que la lectura v1
 * llenaba antes de montar, así que nunca faltaba. Leyéndola del detalle v2 hay una ventana —la
 * primera pintada, con la query todavía en vuelo— en la que no existe.
 *
 * Sin moneda se formatea el número solo. Es lo peor que puede pasar durante un instante, y es
 * mucho mejor que un error boundary.
 */
export function formatMoney(
  amount: number,
  currency?: string | null,
  options: Intl.NumberFormatOptions = {}
): string {
  return new Intl.NumberFormat(
    LOCALE_CURRENCY,
    currency ? { ...options, style: 'currency', currency } : options
  ).format(amount)
}
